import { render } from "./ClientSpace.vue?vue&type=template&id=acfea066&scoped=true"
import script from "./ClientSpace.vue?vue&type=script&lang=js"
export * from "./ClientSpace.vue?vue&type=script&lang=js"

import "./custom-clientSpace.scss?vue&type=style&index=0&id=acfea066&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acfea066"]])

export default __exports__